import React, { useState, useEffect } from "react";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
  {
    id: 1,
    image: "/images/mass-public-rally-leadership.png",
    title: "Voice of the People",
    subtitle: "Strength in Unity",
    description:
      "Standing before thousands with a clear commitment to farmers, workers, and youth. Leading from the front and raising collective voices for justice, rights, and inclusive development."
  },
  {
    id: 2,
    image: "/images/farmers-elders-grassroots-connect.png",
    title: "Respect for Farmers & Elders",
    subtitle: "Roots in Tradition, Eyes on the Future",
    description:
      "Honouring the wisdom and contributions of farmers and senior citizens while staying deeply connected to grassroots values and rural development."
  },
  {
    id: 3,
    image: "/images/youth-sports-promotion.png",
    title: "Promoting Sports & Youth Power",
    subtitle: "Encouraging Talent and Discipline",
    description:
      "Supporting young athletes and strengthening sports culture to inspire discipline, confidence, and national pride among the youth."
  },
  {
    id: 4,
    image: "/images/community-ground-level-engagement.png",
    title: "Connecting with Communities",
    subtitle: "Leadership on the Ground",
    description:
      "Engaging directly with local communities through public interaction and cultural activities, building trust through presence and approachability."
  }
];


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full h-[500px] md:h-[600px] lg:h-[400px] overflow-hidden bg-gray-900">
      {/* Slides Container */}
      <div className="relative w-full h-full">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
              index === currentSlide
                ? "opacity-100 scale-100"
                : "opacity-0 scale-105"
            }`}
          >
            {/* Background Image */}
            <div className="absolute inset-0">
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src =
                    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&h=800&fit=crop";
                }}
              />
              {/* Gradient Overlays */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>

            {/* Content */}
            <div className="relative h-full flex items-center">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="max-w-3xl">
                  {/* Animated Content */}
                  <div
                    className={`transform transition-all duration-1000 delay-300 ${
                      index === currentSlide
                        ? "translate-x-0 opacity-100"
                        : "-translate-x-10 opacity-0"
                    }`}
                  >
                    {/* Subtitle */}
                    <p className="text-green-500 font-bold text-base md:text-lg mb-3 tracking-wider uppercase">
                      {slide.subtitle}
                    </p>

                    {/* Title */}
                    <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                      {slide.title}
                    </h1>

                    {/* Description */}
                    <p className="text-base md:text-lg text-gray-200 mb-6 leading-relaxed max-w-2xl">
                      {slide.description}
                    </p>

                    {/* CTA Buttons */}
                    {/* <div className="flex flex-wrap gap-4">
                      <button className="bg-gradient-to-r from-green-500 to-yellow-500 text-white px-6 md:px-8 py-3 rounded-full font-bold text-sm md:text-base hover:shadow-2xl hover:scale-105 transform transition-all duration-300">
                        View Projects
                      </button>
                      <button className="bg-white/10 backdrop-blur-sm text-white px-6 md:px-8 py-3 rounded-full font-bold text-sm md:text-base border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transform transition-all duration-300">
                        Learn More
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-2 md:p-3 rounded-full transition-all duration-300 hover:scale-110"
        aria-label="Previous slide"
      >
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-2 md:p-3 rounded-full transition-all duration-300 hover:scale-110"
        aria-label="Next slide"
      >
        <svg
          className="w-5 h-5 md:w-6 md:h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2 md:gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`transition-all duration-500 rounded-full ${
              index === currentSlide
                ? "w-10 md:w-12 h-2.5 md:h-3 bg-gradient-to-r from-green-500 to-yellow-500 shadow-lg"
                : "w-2.5 md:w-3 h-2.5 md:h-3 bg-white/50 hover:bg-white/70"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Slide Counter */}
      <div className="absolute top-4 md:top-6 right-4 md:right-6 z-20 bg-white/20 backdrop-blur-sm text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full font-bold text-sm md:text-base">
        <span className="text-lg md:text-xl">{currentSlide + 1}</span>
        <span className="text-xs md:text-sm opacity-70">
          {" "}
          / {slides.length}
        </span>
      </div>

      {/* Animated Progress Bar */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
        <div
          className="h-full bg-gradient-to-r from-green-500 to-yellow-500 transition-all duration-300"
          style={{
            width: `${((currentSlide + 1) / slides.length) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
};

export default HeroSection;
